import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import backgroundImg from './img/background.jpg'

import overlay from './img/overlay.png'

const Intro = ({
  coupleData: { coupleFirstName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro371">
      <div className="index screen">
        <img
          className="background-IO3Fu5"
          src={background || backgroundImg}
          alt="Background"
        />
        <img className="overlay" src={overlay} alt="Overlay" />
        <div className="button-IO3Fu5">
          <p
            className="site-de-casamento-e-fWuS1D"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-fWuS1D smart-layers-pointers">
            <div className="pular-introduo-DGFCer" onClick={onSkipIntro}>
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="couple-name-IO3Fu5 bp2-animate-enter3 notranslate">
          <div className="title-fltOP2 rosaline-regular-normal-white-56px bp2-animate-enter notranslate">
            {coupleFirstName.bride}
          </div>
          <div className="x-fltOP2 rosaline-regular-normal-white-56px bp2-animate-enter1">
            &amp;
          </div>
          <div className="eduardo-fltOP2 rosaline-regular-normal-white-56px bp2-animate-enter2 notranslate">
            {coupleFirstName.groom && coupleFirstName.groom}
          </div>
        </div>
      </div>
      <div className="animated-intro-u8211-small screen">
        <img
          className="background-iJAhTx"
          src={background || backgroundImg}
          alt="Background"
        />
        <img className="overlay" src={overlay} alt="Overlay" />
        <p
          className="site-de-casamento-e-iJAhTx"
          dangerouslySetInnerHTML={{ __html: warningMessage }}
        />
        <div className="button-iJAhTx smart-layers-pointers">
          <div className="pular-introduo-TYwCxA" onClick={onSkipIntro}>
            {buttonMessage}
          </div>
        </div>
        <div className="couple-name-iJAhTx notranslate">
          <div className="title-1bzSmh rosaline-regular-normal-white-48px bp1-animate-enter notranslate">
            {coupleFirstName.bride}
          </div>
          <div className="x-1bzSmh rosaline-regular-normal-white-48px bp1-animate-enter1">
            &amp;
          </div>
          <div className="eduardo-1bzSmh rosaline-regular-normal-white-48px bp1-animate-enter2 notranslate">
            {coupleFirstName.groom && coupleFirstName.groom}
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
